import * as THREE from "three";
import loadingManager from "./loader.js";

const TEX_BASE = './image/textures'

export default function materials(scene, maxAnisotropy = 1) {
    const textureLoader = new THREE.TextureLoader(loadingManager)

    function loadTex(path, isColor = false) {
        const tex = textureLoader.load(path)
        if (isColor) tex.colorSpace = THREE.SRGBColorSpace
        tex.wrapS = tex.wrapT = THREE.RepeatWrapping
        tex.anisotropy = maxAnisotropy
        return tex
    }

    // Для UV-baked текстур (привязаны к конкретной развёртке меша)
    function loadBakedTex(path, isColor = false) {
        const tex = textureLoader.load(path)
        if (isColor) tex.colorSpace = THREE.SRGBColorSpace
        tex.wrapS = tex.wrapT = THREE.ClampToEdgeWrapping
        tex.flipY = false
        tex.anisotropy = maxAnisotropy
        return tex
    }

    // ── WOOD: 4 PBR пресета (расширения файлов разные — собираю руками) ──────
    function woodPBR(dir, colorFile, normalFile, roughFile) {
        const color = loadTex(`${TEX_BASE}/Wood/${dir}/${colorFile}`, true)
        const normal = loadTex(`${TEX_BASE}/Wood/${dir}/${normalFile}`)
        const rough = loadTex(`${TEX_BASE}/Wood/${dir}/${roughFile}`)
        return new THREE.MeshStandardMaterial({
            map: color,
            normalMap: normal,
            roughnessMap: rough,
            roughness: 1.0,
            metalness: 0.0,
        })
    }

    const woodVeneerRedDark = woodPBR(
        'VeneerRedDark001',
        'VeneerRedDark001_COL_2K_METALNESS.png',
        'VeneerRedDark001_NRM_2K_METALNESS.png',
        'VeneerRedDark001_ROUGHNESS_2K_METALNESS.png'
    )
    const woodVeneerWalnut = woodPBR(
        'VeneerWalnutRandomMatched001',
        'VeneerWalnutRandomMatched001_COL_2K_METALNESS.png',
        'VeneerWalnutRandomMatched001_NRM_2K_METALNESS.png',
        'VeneerWalnutRandomMatched001_ROUGHNESS_2K_METALNESS.png'
    )
    const woodFine = woodPBR(
        'WoodFine006',
        'WoodFine006_COL_2K.jpg',
        'WoodFine006_NRM_2K.png',
        'WoodFine006_REFL_2K.jpg'
    )
    const woodQuartered = woodPBR(
        'WoodQuarteredNewMoon001',
        'WoodQuarteredNewMoon001_COL_2K.jpg',
        'WoodQuarteredNewMoon001_NRM_2K.jpg',
        'WoodQuarteredNewMoon001_REFL_2K.jpg'
    )

    // ── CARPET: 3 паттерна, цвет тинтом ──────────────────────────────────────
    function carpetMat(file) {
        const map = loadTex(`${TEX_BASE}/Carpet/${file}`, true)
        return new THREE.MeshStandardMaterial({
            map,
            roughness: 1.0,
            metalness: 0.0,
        })
    }
    const carpetChecker     = carpetMat('CarpetLoopAndCutCheckerboard001/CarpetLoopAndCutCheckerboard001_COL_1K.jpg')
    const carpetHerringbone = carpetMat('CarpetLoopAndCutHerringbone002/CarpetLoopAndCutHerringbone002_COL_1K.jpg')
    const carpetArrows      = carpetMat('CarpetLoopPilePlainArrows001/CarpetLoopPilePlainArrows001_COL_1K.jpg')

    // ── DECK 1/2/3 + DeckStairs: 4 материала в модели, каждый со своим bake ──
    // Текстуры — UV-baked, ClampToEdge. Цвет = свой COL-bake; ROUGHNESS общий.
    function buildDeckGroup(prefix, roughFile) {
        const dir = `${TEX_BASE}/Deck/${prefix}/`
        const roughMap = loadBakedTex(`${dir}${roughFile}`)
        function variant(colorFile) {
            return new THREE.MeshStandardMaterial({
                map: loadBakedTex(`${dir}${colorFile}`, true),
                roughnessMap: roughMap,
                roughness: 1.0,
                metalness: 0.0,
            })
        }
        return {
            brown: variant(`${prefix}BrownCOL.jpg`),
            gray:  variant(`${prefix}GrayCOL.jpg`),
            light: variant(`${prefix}LightCOL.jpg`),
            red:   variant(`${prefix}RedCOL.jpg`),
        }
    }
    const deck1      = buildDeckGroup('Deck1',      'Deck1ROUGNESS.png')   // sic: файл назван ROUGNESS
    const deck2      = buildDeckGroup('Deck2',      'Deck2ROUGHNESS.png')
    const deck3      = buildDeckGroup('Deck3',      'Deck3ROUGHNESS.png')
    const deckStairs = buildDeckGroup('DeckStairs', 'DeckStairsROUGHNESS.png')

    // Прогрев: добавим невидимый меш на каждый материал, чтобы шейдер скомпилился
    const tempGeo = new THREE.PlaneGeometry(0.001, 0.001)
    const allMats = [
        woodVeneerRedDark, woodVeneerWalnut, woodFine, woodQuartered,
        carpetChecker, carpetHerringbone, carpetArrows,
        ...Object.values(deck1), ...Object.values(deck2),
        ...Object.values(deck3), ...Object.values(deckStairs),
    ]
    allMats.forEach(mat => {
        const m = new THREE.Mesh(tempGeo, mat)
        m.visible = false
        scene.add(m)
    })

    return {
        wood: {
            redDark:   woodVeneerRedDark,
            walnut:    woodVeneerWalnut,
            fine:      woodFine,
            quartered: woodQuartered,
        },
        carpet: {
            checker:     carpetChecker,
            herringbone: carpetHerringbone,
            arrows:      carpetArrows,
        },
        deck1, deck2, deck3, deckStairs,
    }
}
